import isEmptyString from "../utils/isEmptyString";
import { tooOldMessage, tooYoungMessage, PHONE_NUMBERS, FUNNEL_NAMES, DOB_MUST_BE_IN_PAST_MESSAGE, iapTooYoungMessage, iapTooOldMessage } from "../utils/common";
var validYear = function validYear(yearEntered) {
  var maxYearsAgo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var minYearsAgo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var funnel = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "ARHI";
  var isDependant = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var isPartner = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var customApplicantType = arguments.length > 6 ? arguments[6] : undefined;
  var today = new Date();
  var currentYear = today.getFullYear();
  var yearEnteredNum = parseInt(yearEntered);
  var funnelPhone = PHONE_NUMBERS[funnel];
  var funnelName = FUNNEL_NAMES[funnel];
  var applicationType = isDependant ? "dependants" : "applicants";
  var errors;
  if (isEmptyString(yearEntered)) {
    errors = "Year is required.";
  } else if (yearEntered.length !== 4) {
    errors = "Valid year required";
  } else {
    if (yearEnteredNum > currentYear) {
      errors = DOB_MUST_BE_IN_PAST_MESSAGE;
    } else {
      if (yearEnteredNum < currentYear - maxYearsAgo) {
        errors = funnel !== "IAP" ? tooOldMessage(applicationType, maxYearsAgo, funnelName, funnelPhone, funnel, isDependant, isPartner) : iapTooOldMessage(maxYearsAgo, isDependant, isPartner, customApplicantType);
      }
      if (yearEnteredNum > currentYear - minYearsAgo) {
        errors = funnel !== "IAP" ? tooYoungMessage(minYearsAgo, funnelName, funnelPhone, funnel, isDependant, isPartner) : iapTooYoungMessage(minYearsAgo, isPartner, customApplicantType);
      }
    }
  }
  return errors;
};
export default validYear;